export default {
  allowMessage: () => (entry) => {
    const name = entry.get('allowed').get('name')
    if (name === 'disallowed') {
      return 'このユーザーの参加を許可しますか？'
    }
    return 'このユーザーの参加を取り消しますか？'
  },

  removeMessage: () => (entry) => {
    return 'このユーザーのエントリーを取り消しますか？'
  }
}
